import { Popup } from "devextreme-react";
import { BankInfo } from "./settings";


function BankInfoPopup({ visible, onHide }) {

    return (
        <Popup
            visible={visible}
            onHiding={onHide}
            width={500}
            height={600}
            title="Kayıt Ekle"
            showTitle={false}
            hideOnOutsideClick={true}
        >
            <BankInfo>

            </BankInfo>
        </Popup>

    )
}

export default BankInfoPopup